<app-view-item *ngIf="readonly" [text]="selected?.code" [tabindex]="tabindex"></app-view-item>
<div class="supplier-select-container" *ngIf="!readonly">
  <nz-select #selector nzShowSearch nzServerSearch [nzAllowClear]="nzAllowClear" [nzBackdrop]="addBackdrop"
    [nzFilterOption]="nzFilterOption" (nzOnSearch)="onSearch($event)" (nzOpenChange)="onDropdownOpenChange($event)"
    [nzCustomTemplate]="displayTpl" (nzScrollToBottom)="loadMore()" (keydown)="handleKeyDown($event)"
    (click)="handleClick($event)" [(ngModel)]="value" (ngModelChange)="valueChanged($event)"
    [nzDropdownMatchSelectWidth]="false" nzDropdownClassName="dropdownSelect" class="width-100" [nzOptionHeightPx]="60" [nzOptionOverflowSize]="4"
    [nzPlacement]="'bottomLeft'" [tabindex]="tabindex">
    <!-- [nzOptionHeightPx]="55" -->
    <ng-template #displayTpl let-selected>
      {{ selected.nzLabel }}
    </ng-template>
    <!-- Custom Add New Button at top -->
    <ng-container *aclIf="{ ability: ['m1.4', 'supplier.create'], mode: 'allOf' }">
      <nz-option *ngIf="!searching && showAddNewButton && !this.NotShowInReport" [nzValue]="null" [nzLabel]="'__addnew__'" nzCustomContent>
        <div class="text-center">
          <button type="button" nz-button nzType="primary" class="add-new-button" (click)="$event.stopPropagation(); onAddNewClick($event)">
            <span nz-icon nzType="plus"></span>
            {{ storedInstantData ? ' Add New \''+ storedInstantData +'\'' : ' Add New' }}
          </button>
        </div>
      </nz-option>
    </ng-container>

    <!-- OCR Suggested Items Section -->
    <ng-container *ngIf="!searching && ocrSuggested && ocrSuggested.length > 0">
      <!-- Suggested Label -->
      <nz-option [nzValue]="'__section_label__'" [nzLabel]="'Suggested'" nzDisabled nzCustomContent>
        <div class="section-label suggested-label">
          <span class="label-text">Suggested</span>
        </div>
      </nz-option>

      <!-- OCR Suggested Items -->
      <nz-option *ngFor="let suggestion of ocrSuggested" [nzValue]="'__ocr_suggested__' + suggestion"
        [nzLabel]="suggestion" nzCustomContent>
        <div class="ocr-suggested-item" (click)="onOcrSuggestedClick(suggestion, $event)">
          <span class="ocr-text">{{ suggestion }}</span>
        </div>
      </nz-option>
    </ng-container>

    <!-- Suppliers Section Label -->
    <ng-container *ngIf="!searching && list && list.length > 0 && ocrSuggested">
      <nz-option [nzValue]="'__section_label__'" [nzLabel]="'Suppliers'" nzDisabled nzCustomContent>
        <div class="section-label suppliers-label">
          <span class="label-text">Suppliers</span>
        </div>
      </nz-option>
    </ng-container>

    <ng-container *ngFor="let o of list">
      <ng-container *ngIf="!excludedList.includes(o.id) && o !== 'addNew'">
        <nz-option *ngIf="!searching" [nzValue]="getValue(o)" [nzLabel]="getLabel(o)" nzCustomContent>
          <app-supplier-select-item [supplier]="o"></app-supplier-select-item>
        </nz-option>
      </ng-container>
    </ng-container>
  </nz-select>

  <!-- Inline Add Panel -->
  <app-inline-add-panel #inlineAddPanel [config]="supplierConfig" [visible]="showInlineAddPanel"
    [initialData]="inlineDefaults" (itemCreated)="onSupplierCreated($event)" (cancelled)="onSupplierCancelled()"
    (visibleChange)="showInlineAddPanel = $event" (moreDetails)="onSupplierMoreDetails()"
    (fieldChange)="onFieldChange($event)">
  </app-inline-add-panel>
</div>